<template>
  <MetalView v-if="metal" :metal zone="metal-detail" @close="$emit('close')">
    <!-- Extend into the wide reader. The ≥768 gate lives inside the button. -->
    <template #actions>
      <ExtendButton
        :label="i18n(translations.extendLabel)"
        @click="handleExtend()"
      />
    </template>
  </MetalView>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import ExtendButton from '~/scopes/campaign/components/UI/ExtendButton.vue'
import MetalView from '~/scopes/campaign/components/highlights/metal/MetalView.vue'
import { useModalState } from '~/scopes/campaign/composables/useModalState'
import { metalBySlug } from '~/scopes/campaign/data/metals/data'

import translations from './MetalDetail.translations'

// The narrow panel's state adapter — the shape `ArticleDetail` has. Mounted twice by
// `ModalHighlights`: the library detail (`/metal/:id`, no `slug`) and the `?metal=` quick
// view (`slug` passed). Both resolve the same view; only the closer differs, which is the
// caller's business, not this component's.
//
// Its root must stay a single node: it is a `<ContentSwap>` child in both mounts, and a
// fragment root would leave the outgoing metal in the DOM — see the note in
// `metal/MetalView.vue`.
const props = defineProps<{ slug?: string }>()
defineEmits<{ close: [] }>()

const i18n = useI18n()
const { trackClick } = useTracking()
const { activeDetail, openMetalReader } = useModalState()

const metal = computed(() => metalBySlug(props.slug ?? activeDetail.value))

// work — and the reader needs no id: the path (or `?metal=`) already carries the metal.
function handleExtend() {
  trackClick({ zone: 'metal-detail', name: 'extend' })
  openMetalReader()
}
</script>
